import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from "../../Config/constants";

const service = AxiosClient.getInstance();

//Get Subscription Details
export const getSubscriptionDetails = async () => {
  const url = `${ENV}${SERVICE.SUBSCRIPTION.GET_SUBSCRIPTION_DETAILS}`;
  return service.GetApiRequest(url);
};


/**
 * @description Gets the subscription info of the user.
 * @returns Subscription response.
 */
export const getSubscriptionInfoApi = async () => {
  const URL = `${ENV}${SERVICE.SUBSCRIPTION.GET_SUBSCRIPTION_INFO}`;
  return service.GetApiRequest(URL);
}